import { render, staticRenderFns } from "./RadarChartDialog.vue?vue&type=template&id=3e8c4881"
import script from "./RadarChartDialog.vue?vue&type=script&lang=ts"
export * from "./RadarChartDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports